import { AlertColor } from "@mui/material";
import { WorkedStatus } from "../component/time-sheet-logs/enums/workedStatus.enum";

export interface WorkedStatusUIConfig {
  bg: string;
  text: string;
  border: string;
  label: string;
  alertColor: AlertColor;
  message: string;
}

export const workedStatusConfig: Record<WorkedStatus, WorkedStatusUIConfig> = {
  [WorkedStatus.COMPLETED]: {
    bg: "#dcfce7",
    text: "#166534",
    border: "#86efac",
    label: "Completed",
    alertColor: "success",
    message: "Success",
  },
  [WorkedStatus.COMPLETED_LATE_START]: {
    bg: "#fff7ed",
    text: "#c2410c",
    border: "#fed7aa",
    label: "Late Start",
    alertColor: "warning",
    message: "Late Entry",
  },
  [WorkedStatus.COMPLETED_OVERTIME]: {
    bg: "#eff6ff",
    text: "#1e40af",
    border: "#bfdbfe",
    label: "Extra Time",
    alertColor: "info",
    message: "Overtime",
  },
  [WorkedStatus.COMPLETED_LATE]: {
    bg: "#fef2f2",
    text: "#991b1b",
    border: "#fecaca",
    label: "Delayed",
    alertColor: "error",
    message: "Late arrival & exit",
  },
  [WorkedStatus.IN_PROGRESS]: {
    bg: "#fefce8",
    text: "#854d0e",
    border: "#fef08a",
    label: "In Progress",
    alertColor: "warning",
    message: "On going",
  },
  [WorkedStatus.MISSING_CHECKOUT]: {
    bg: "#fafafa",
    text: "#525252",
    border: "var(--fx-surface-border, #E2E8F0)",
    label: "No Checkout",
    alertColor: "warning",
    message: "Missing Out",
  },
  [WorkedStatus.NOT_STARTED]: {
    bg: "#f9fafb",
    text: "#4b5563",
    border: "var(--fx-surface-border, #E2E8F0)",
    label: "Pending",
    alertColor: "info",
    message: "Not started",
  },
  [WorkedStatus.INVALID]: {
    bg: "#fee2e2",
    text: "#991b1b",
    border: "#f87171",
    label: "Invalid",
    alertColor: "error",
    message: "Invalid",
  },
};

export const getWorkedStatusConfig = (status?: WorkedStatus): WorkedStatusUIConfig => {
  if (!status) return workedStatusConfig.invalid;
  return workedStatusConfig[status] ?? workedStatusConfig.invalid;
};
